import React, { useState } from 'react'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import SegmentedToggleButton from 'components/segmented-toggle-button/mui5'
import { segmentedToggleButtonGroupSx } from 'lib/segmented-button-styles'

const YesNoToggle = ({ attended, index, register }) => {
  const [response, setResponse] = useState(
    attended === true || attended === null,
  )

  const handleResponse = (event, newResponse) => {
    if (newResponse !== null) {
      setResponse(newResponse)
    }
  }

  return (
    <ToggleButtonGroup
      value={response}
      exclusive
      onChange={handleResponse}
      aria-label="response"
      sx={segmentedToggleButtonGroupSx}
    >
      <input
        type="hidden"
        value={response}
        name={`enrollments.${index}.attended`}
        ref={register()}
      />
      <SegmentedToggleButton
        value={true}
        groupValue={response}
        aria-label="Yes"
      >
        Yes
      </SegmentedToggleButton>
      <SegmentedToggleButton
        value={false}
        groupValue={response}
        aria-label="No"
      >
        No
      </SegmentedToggleButton>
    </ToggleButtonGroup>
  )
}

export default YesNoToggle
